import React from "react";
import { Tab, Tabs, NavLink } from "../../components";
import { makeStyles } from "@material-ui/styles";
import sharedStyles from "../styles";
const useStyles = makeStyles(sharedStyles);
export default function SearchTabs({ tabIndex, permissions }) {
  const classes = useStyles();
  return (
    <Tabs value={tabIndex} className={classes.tabHeader} textColor="primary">
     {permissions?.workflows?.active === "True" &&  permissions?.workflows?.hide === "False" && <Tab label="Workflows" component={NavLink} path="/" />}
      {permissions?.tasks?.active === "True" &&  permissions?.tasks?.hide === "False" && <Tab label="Tasks" component={NavLink} path="/search/tasks" />}
    </Tabs>
  );
}
